import { defineAsyncComponent } from 'vue'
export default {
  base: defineAsyncComponent(() => import("C:/Users/brend/GIT/tgi-partner-rentprotect/layouts/base.vue").then(m => m.default || m))
}